export default "__VITE_ASSET__7802537b__"